import React, { useState } from "react";
import { Heading, Box, Card, Button } from "theme-ui";

import {
  Decimal,
  Decimalish,
  Difference,
  LiquityStoreState,
  LQTYStake,
} from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";

import { COIN, GT } from "../../strings";

import { Icon } from "../Icon";
import { EditableRow, StaticRow } from "../Trove/Editor";
import { LoadingOverlay } from "../LoadingOverlay";

import { useStakingView } from "./context/StakingViewContext";

const select = ({ lqtyBalance, totalStakedLQTY, sPrintBalance }: LiquityStoreState) => ({
  lqtyBalance,
  totalStakedLQTY,
  sPrintBalance
});

type StakingEditorProps = {
  title: string;
  originalStake: LQTYStake;
  editedLQTY: Decimal;
  mode: string;
  dispatch: (
    action: { type: "setStake"; newValue: Decimalish } | { type: "revert" }
  ) => void;
};

export const StakingEditor: React.FC<StakingEditorProps> = ({
  children,
  title,
  originalStake,
  editedLQTY,
  mode,
  dispatch,
}) => {
  const { lqtyBalance, sPrintBalance } = useLiquitySelector(select);
  const { changePending } = useStakingView();
  const editingState = useState<string>();
  const titleBalance = mode == "stake" ? ` ${Number(lqtyBalance).toFixed(2)} PRINT` : `${Number(sPrintBalance).toFixed(2)} sPRINT`

  const edited = !editedLQTY.eq(originalStake.stakedLQTY);
  const maxAmount = mode == "stake" ? lqtyBalance : sPrintBalance;
  const maxedOut = editedLQTY.eq(maxAmount);

  const tokensPrice = JSON.parse(localStorage.getItem("tokensPrice") || "{}");
  const earnPrice = tokensPrice.PRINT || 0;

  return (
    <Card>
      <Heading>
        <div>
          <Icon style={{ marginRight: 10, color: "#00afff" }} name="database" />
          {`${title} | Bal: ${titleBalance}`}
        </div>
        {edited && !changePending && (
          <Button
            variant="titleIcon"
            sx={{ ":enabled:hover": { color: "danger" } }}
            onClick={() => dispatch({ type: "revert" })}
          >
            <Icon name="history" size="lg" />
          </Button>
        )}
      </Heading>

      <Box sx={{ p: [2, 3] }}>
        <EditableRow
          label={mode}
          inputId="sprint-lqty"
          amount={editedLQTY.prettify()}
          maxAmount={maxAmount.toString()}
          maxedOut={maxedOut}
          unit={GT}
          {...{ editingState }}
          editedAmount={editedLQTY.toString(2)}
          setEditedAmount={(newValue) =>
            dispatch({ type: "setStake", newValue })
          }
          usdval={earnPrice?.toString()}
        />

        {children}
      </Box>

      {changePending && <LoadingOverlay />}
    </Card>
  );
};
